export default "/images/skill.png?45e38689d7d2add3841670bb65cf46bf";